import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useExpensesStore } from '../../store/expensesStore'
import { updateExpense } from '../../utils/updateExpense'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUpdateExpenseMutation = (onSuccess?: () => void) => {
  const editExpense = useExpensesStore((state) => state.updateExpense)

  return useMutation({
    mutationFn: updateExpense,
    onSuccess: ({ message, expense }) => {
      editExpense(expense)
      toast.success(message || 'Expense updated successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while updating the expense.')
    },
  })
}
